module.exports = __webpack_public_path__ + "img/swaziland.5bd3696a.svg";